const getLoggedUserId = function () {
    return (app.store.getState().session.user || {}).id;
};

export default {
    loadEventMeetings: function (eventId, organized, invited, fetchTime) {
        return {
            type: 'EVENT_MEETINGS_LOADED',
            eventId,
            meetings: {
                organized: organized.map((meeting) => ({ ...meeting, _organized: true })),
                invited: invited.map((meeting) => ({ ...meeting, _invited: true })),
            },
            userId: getLoggedUserId(),
            fetchTime,
        };
    },
    meetingCreated: function (eventId, meeting) {
        return { type: 'EVENT_MEETING_CREATED', eventId, meeting, userId: getLoggedUserId() };
    },
    meetingUpdate: function (eventId, meeting) {
        return { type: 'EVENT_MEETING_CHANGED', eventId, meeting, userId: getLoggedUserId() };
    },
    slotBlock: function (eventId, meetingId, blocked) {
        return { type: 'EVENT_MEETING_SLOT_BLOCK', eventId, meetingId, blocked };
    },
};
